import { appendProtocol } from '@/postContentElement/components/utils/link';
import { usePostContentContext } from '@/postContentElement/context';
import { evaluateAndAppendUTMParams } from '@/utils/evaluateAndAppendUTMParams';

interface Props {
  anchorId?: string;
  dataOrigin?: string;
  messageId?: string;
  messageContent?: string;
  messageUrl?: string;
  profileName?: string;
  profileUsername?: string;
  postedAt?: string;
}

const Stocktwits = ({
  anchorId,
  dataOrigin,
  messageId,
  messageContent,
  messageUrl,
  profileName,
  profileUsername,
  postedAt,
}: Props) => {
  const { utmParams } = usePostContentContext();
  const messageUrlWithUTMParams = evaluateAndAppendUTMParams(appendProtocol(messageUrl), utmParams);

  return (
    <div className="py-2">
      <div className="stocktwits-wrapper max-w-[520px] mx-auto" id={anchorId}>
        <blockquote className="stocktwits-embedded-post text-center" data-origin={dataOrigin} data-id={messageId}>
          {messageContent && (
            <p
              lang="en"
              dir="ltr"
              dangerouslySetInnerHTML={{
                __html: messageContent,
              }}
            />
          )}
          <a href={messageUrlWithUTMParams}>
            <p>
              &mdash; {profileName} ({profileUsername})
              <br />
              {postedAt}
            </p>
          </a>
        </blockquote>
      </div>
    </div>
  );
};

export { Stocktwits };
